import makeApiCall from "./axiosIndex";
const brandMasterApis = {
  fetchBrandWithPagination: (params: any): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchMaterialBrandsWithPagination",
      method: "get",
      params,
    });
  },
  fetchBrandDropDown: (): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchBrandsDropDown",
      method: "get",
    });
  },

  fetchBrandById: (id: number): Promise<any> => {
    return makeApiCall({
      url: `/buyer/fetchBrandsByMaterialId`,
      method: "get",
      params: { id },
    });
  },

  updateBrandById: (id: number, data: any): Promise<any> => {
    return makeApiCall({
      url: `/buyer/updateBrandById`,
      method: "put",
      params: { id },
      data,
    });
  },

  createBrand: (data: any): Promise<any> => {
    return makeApiCall({
      url: `/buyer/createBrand`,
      method: "post",
      data,
    });
  },

  deleteBrandById: (id: number): Promise<any> => {
    return makeApiCall({
      url: "/buyer/deleteBrandForMaterialById",
      method: "delete",
      params: { id },
    });
  },

  // status
  allowActiveStatus: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/buyer/activateBrandForMaterialById`,
      params: { id },
    }),

  removeActiveStatus: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/buyer/inActivateBrandForMaterialById`,
      params: { id },
    }),
};

export default brandMasterApis;
